(() => {
  // app/scripts/view-toggle.js
  var LOCAL_STORAGE_KEY = "view-toggle";
  var ViewToggle = class extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector("input");
      this.controls = this.querySelectorAll("[data-view]");
      this.handleClick = this.handleClick.bind(this);
    }
    connectedCallback() {
      this.controls.forEach((el) => el.addEventListener("click", this.handleClick));
    }
    disconnectedCallback() {
      this.controls.forEach((el) => el.removeEventListener("click", this.handleClick));
    }
    handleClick(event) {
      const el = event.currentTarget;
      const isList = el.dataset.view === "list";
      if (this.input)
        this.input.checked = isList;
      this.controls.forEach((c) => {
        c.setAttribute("aria-pressed", String(c.dataset.view === "list" === isList));
      });
      const { target, className } = el.dataset;
      if (target && className) {
        const classes = className.split(",").map((c) => c.trim()).filter(Boolean);
        document.querySelectorAll(target).forEach((node) => {
          classes.forEach((c) => node.classList.toggle(c, isList));
        });
      }
      localStorage.setItem(LOCAL_STORAGE_KEY, isList ? "list-view" : "grid-view");
    }
  };
  customElements.define("view-toggle", ViewToggle);
})();
